import React, { useState } from 'react';
import TextField from '@mui/material/TextField';

const MassEditSmileName = ({ handleUpdate }) => {
  const [smileName, setSmileName] = useState('');

  const handleChange = (event) => {
    setSmileName(event.target.value);
  };

  const handleClick = () => {
    handleUpdate(smileName);
  };

  return (
    <div className='ml-3'>
      <TextField
        id="outlined-controlled"
        label="Smile Name"
        value={smileName}
        onChange={handleChange}
        size="small"
      />
      <button onClick={handleClick} className='btn-primary mx-3'>Update Smile Name</button>
    </div>
  );
};

export default MassEditSmileName;
